/**
 * Custom slider functionality for nsSteps.js module
 * - calculate position of the slider and playing with translateX property.
 * - using for all screen size (the width of slides is fixed)
 */
const $ = window.jquery;
const SLIDE_WIDTH_DESKTOP = 200;
const SLIDE_WIDTH_MOBILE = 120;
const ARROWS_SPACE_DESKTOP = 80;
const ARROWS_SPACE_MOBILE = 40;

export default class stepsSlider {
  constructor() {
    this.$steps = null;
    this.$stepsInner = null;
    this.slideCount = 0;
    this.activeSlide = 0;
    this.slideCentered = 0;
    this.wrapperWidth = 0;
    this.visibleSlides = 0;
    this.slideWidth = null;
    this.arrowSpace = null;
  }

  /**
   * Initialize slider and set all needed elements.
   */
  initSlider() {
    if (window.innerWidth >= 460) {
      this.slideWidth = SLIDE_WIDTH_DESKTOP;
      this.arrowSpace = ARROWS_SPACE_DESKTOP;
    }
    else {
      this.slideWidth = SLIDE_WIDTH_MOBILE;
      this.arrowSpace = ARROWS_SPACE_MOBILE;
    }
    this.slideCount = this.$stepsInner.children().length;
    this.wrapperWidth = this.$stepsInner.outerWidth();
    this.visibleSlides = parseInt(this.wrapperWidth / this.slideWidth);
    this.slideCentered = parseInt(this.visibleSlides / 2) > 0 ? parseInt(this.visibleSlides / 2) : 1;
    this.activeSlide = 0;

    // Set steps outerWrapper width (check if there are less slides than available space).
    let sliderWidth = this.visibleSlides < this.slideCount ?
      (this.slideWidth * this.visibleSlides) + (this.arrowSpace * 2)
      : (this.slideCount * this.slideWidth) + (this.arrowSpace * 2);
    // Hide prev/next buttons if there's more space than currently necessary.
    if (this.visibleSlides < this.slideCount) {
      this.$steps.find('button.slider-prev, button.slider-next').show();
    }
    else {
      this.$steps.find('button.slider-prev, button.slider-next').hide();
    }
    this.$steps.css('width', sliderWidth);

    // Set stepsInner container width.
    this.$stepsInner.attr('data-translation', 0);
    this.$stepsInner.css('transform', 'translateX(0)');
  }

  /**
   * Triggering the slide functionalities.
   * @param currentIndex
   * @param prevIndex
   */
  activeSlideChange(currentIndex, prevIndex) {
    currentIndex += 1; // Increase by 1 because started with 0.

    // Calling debug function.
    // this.debug(currentIndex, prevIndex);

    // Check if move is needed.
    if(currentIndex > this.slideCentered && this.slideCount > this.visibleSlides) {
      // Check if we have visible just one slide.
      let slideCC =  this.visibleSlides === 1 ? this.slideCount : this.slideCount - this.slideCentered;

      // Check if we are already scroll to start/end.
      if(slideCC >= currentIndex) {
        let countFromCenter = currentIndex - this.slideCentered;
        let calcTrans = this.slideWidth * countFromCenter;

        this.$stepsInner.css('transform', `translateX(${-calcTrans}px)`);
      }
      // Move it to max to left if step is clicked.
      else {
        let countSlides = slideCC - this.slideCentered;

        // Only positive countSlides.
        if(countSlides > 0) {
          let calcTrans = this.slideWidth * countSlides;

          this.$stepsInner.css('transform', `translateX(${-calcTrans}px)`);
        }
      }
    }
    else {
      // Set slider to beginning.
      this.$stepsInner.css('transform', `translateX(0px)`);
    }
  }

  /**
   * Get slide
   * @param index
   * @returns {boolean|{length}|*}
   */
  getSlide(index) {
    let slide = this.$stepsInner.children().eq(index);

    if (!slide.length) {
      return false;
    }

    return slide;
  }

  /**
   * Setting steps jQuery object.
   * @param $steps
   * @param resize
   */
  setSteps($steps, resize = false) {
    this.$steps = $steps;
    this.$stepsInner = $steps.find('ul');
    // Set width to 100% in case of resize happened.
    this.$steps.css('width', '100%');

    // If calls from resize function active 1st slide.
    if(resize) {
      // Target first slide and click on A elem.
      this.$stepsInner
        .children()
        .eq(0)
        .find('a')
        .click();
    }

    this.initSlider();
  }

  /**
   * Debug function.
   * @param currentIndex
   * @param prevIndex
   */
  debug(currentIndex, prevIndex){
    console.log('**********Steps slider data************');
    console.log('Current index: ' + currentIndex);
    console.log('Prev index: ' + (prevIndex + 1));
    console.log('Slide count: ' + this.slideCount);
    console.log('Visible slides: ' + this.visibleSlides);
    console.log('Centered slides: ' + this.slideCentered);
    console.log('Wrapper width: ' + this.wrapperWidth);
  }
}
